var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMlp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 13,
    viewBox: "0 0 33 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.752 0.7H12.952V12.5H10.6V2.164L10.648 2.196L8.344 12.5H5.096L2.752 2.172L2.8 2.148V12.5H0.440001V0.7H4.64L6.792 11.324H6.584L8.752 0.7ZM15.3279 12.5V0.7H17.8159V11.756L16.6959 10.476H22.2079V12.5H15.3279ZM26.5734 12.5H24.0854V0.7H28.1254C29.0267 0.7 29.7974 0.876 30.4374 1.228C31.0827 1.57467 31.5734 2.04667 31.9094 2.644C32.2507 3.236 32.4214 3.90533 32.4214 4.652C32.4214 5.39333 32.248 6.07333 31.9014 6.692C31.56 7.30533 31.0694 7.79867 30.4294 8.172C29.7894 8.54 29.0214 8.724 28.1254 8.724H26.5734V12.5ZM26.5734 7.956L25.4534 6.804H27.8614C28.2774 6.804 28.64 6.72133 28.9494 6.556C29.2587 6.38533 29.4987 6.14 29.6694 5.82C29.84 5.49467 29.9254 5.10533 29.9254 4.652C29.9254 4.19333 29.84 3.81467 29.6694 3.516C29.504 3.212 29.2667 2.988 28.9574 2.844C28.6534 2.69467 28.288 2.62 27.8614 2.62H25.4534L26.5734 1.436V7.956Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlp);
export default __webpack_public_path__ + "static/media/MLP.24ab51baccfd3ac7fe1fb46220c23b51.svg";
export { ForwardRef as ReactComponent };